import { ReactNode } from 'react';
import noop from 'lodash/noop';
import { RadioGroup, Radio } from '@dealroadshow/uikit-input/Radio';
import { FormStateSpecification } from '@dealroadshow/uikit-form';
import { Field } from '@framework/ui/Organisms/FinalForm';
import Tooltip from '@dealroadshow/uikit-tooltip';
import IconQuestion from '@dealroadshow/uikit-icon/IconQuestion';

import { IQuestion, IRadioButtonAnswer } from '../interfaces';
import getQuestionTextValue from '../helpers/getQuestionTextValue';
import { useCallFormContext } from '../CallFormContext';

import styles from './questionFields.module.scss';

export interface IProps extends IQuestion {
  onChange?: () => void,
  disabled?: boolean,
  renderAnswerContent?: (answer: IRadioButtonAnswer) => ReactNode,
}

const QuestionRadioButtonField = (
  {
    name,
    onChange = noop,
    radioButtonAnswers = [],
    disabled = false,
    renderAnswerContent,
  }: IProps,
) => {
  const { instance } = useCallFormContext();
  return (
    <Field
      name={ name }
      render={ (fieldProps) => (
        <RadioGroup
          { ...fieldProps.input }
          onChange={ (event) => {
            fieldProps.input.onChange(event);
            onChange();
          } }
          isNarrow
          isErrorMessage={ FormStateSpecification.error(fieldProps.meta) }
          selectedValue={ fieldProps.input.value }
          disabled={ disabled }
          dataTest={ name }
          direction="vertical"
          { ...fieldProps }
        >
          {
            radioButtonAnswers.map((answer) => {
              return (
                <div key={ answer.value }>
                  <Radio
                    dataTest={ answer.dataTest }
                    value={ answer.value }
                    label={ (
                      <>
                        { getQuestionTextValue(answer.label, instance) }
                        { answer.explanation && (
                          <Tooltip
                            containerClassName={ styles.explanationIconContainer }
                            content={ getQuestionTextValue(answer.explanation, instance) }
                          >
                            <IconQuestion className={ styles.explanationIcon } />
                          </Tooltip>
                        ) }
                      </>
                    ) }
                  />
                  { renderAnswerContent?.(answer) }
                </div>
              );
            })
          }
        </RadioGroup>
      ) }
    />
  );
};

export default QuestionRadioButtonField;
